import { MultiSelectGroup } from '../MultiselectDropdown';
import {
  AdminPermission,
  AdvisorPermission,
  CsmPermission,
  InventoryPermission,
  SdmPermission,
  SupportPermission,
  SupportCasePermission,
  TeamManagerPermission,
  ExecutivePermission,
  CostIntelligencePermission,
  CostAnalyticsPermission
} from '../../../store/GeneralStore';
import { ADVISE_ROLES, ADVISE_STAFF_ROLES } from '../../../store/Role';

export const roleGroups: MultiSelectGroup[] = [
  {
    title: 'Inventory',
    items: [
      {
        label: 'Full Access',
        options: Object.values(InventoryPermission),
        mutualExclusiveWith: ['Inventory - View']
      },
      {
        label: 'View Only',
        options: Object.values(InventoryPermission),
        mutualExclusiveWith: ['Inventory - Full']
      }
    ]
  },
  {
    title: 'Support Cases',
    items: [
      {
        label: 'Full Access',
        options: Object.values(SupportCasePermission),
        mutualExclusiveWith: ['Support Cases - View']
      },
      {
        label: 'View Only',
        options: Object.values(SupportCasePermission),
        mutualExclusiveWith: ['Support Cases - Full']
      }
    ]
  },
  {
    title: 'Admin',
    items: [
      {
        label: 'Full Access',
        options: Object.values(AdminPermission),
        mutualExclusiveWith: [
          'Support',
          'Advisor',
          'Customer Success Manager',
          'Service Delivery Manager',
          'Executive - View',
          'Executive - Full',
          'Team Manager'
        ]
      }
    ]
  },
  {
    title: 'Advisor',
    items: [
      {
        label: 'Full Access',
        options: Object.values(AdvisorPermission),
        mutualExclusiveWith: [
          'Support',
          'Admin',
          'Executive - View',
          'Executive - Full',
          'Customer Success Manager',
          'Service Delivery Manager'
        ]
      }
    ]
  },
  {
    title: 'SDM',
    items: [
      {
        label: 'Full Access',
        options: Object.values(SdmPermission) as string[],
        mutualExclusiveWith: [
          'Support',
          'Admin',
          'Executive - View',
          'Executive - Full',
          'Advisor',
          'Customer Success Manager',
          ...ADVISE_ROLES
        ]
      }
    ]
  },
  {
    title: 'CSM',
    items: [
      {
        label: 'Full Access',
        options: Object.values(CsmPermission) as string[],
        mutualExclusiveWith: [
          'Support',
          'Admin',
          'Executive - View',
          'Executive - Full',
          'Advisor',
          'Service Delivery Manager'
        ]
      }
    ]
  },
  {
    title: 'Support',
    items: [
      {
        label: 'Full Access',
        options: Object.values(SupportPermission) as string[],
        mutualExclusiveWith: [
          'Admin',
          'Advisor',
          'Customer Success Manager',
          'Service Delivery Manager',
          'Executive - View',
          'Executive - Full',
          'Team Manager',
          ...ADVISE_STAFF_ROLES
        ]
      }
    ]
  },
  {
    title: 'Team Manager',
    items: [
      {
        label: 'Full Access',
        options: Object.values(TeamManagerPermission),
        mutualExclusiveWith: ['Admin', 'Support', 'Executive - View', 'Executive - Full', ...ADVISE_STAFF_ROLES]
      }
    ]
  },
  {
    title: 'Executive',
    items: [
      {
        label: 'Full Access',
        options: Object.values(ExecutivePermission) as string[],
        mutualExclusiveWith: [
          'Admin',
          'Advisor',
          'Customer Success Manager',
          'Service Delivery Manager',
          'Support',
          'Executive - View',
          'Team Manager',
          ...ADVISE_ROLES
        ]
      },
      {
        label: 'View Only',
        options: Object.values(ExecutivePermission) as string[],
        mutualExclusiveWith: [
          'Admin',
          'Advisor',
          'Customer Success Manager',
          'Service Delivery Manager',
          'Support',
          'Executive - Full',
          'Team Manager',
          ...ADVISE_ROLES
        ]
      }
    ]
  },
  {
    title: 'Cost Intelligence',
    items: [
      {
        label: 'Full Access',
        options: Object.values(CostIntelligencePermission),
        mutualExclusiveWith: []
      }
    ]
  },
  {
    title: 'Cost Analytics',
    items: [
      {
        label: 'Full Access',
        options: Object.values(CostAnalyticsPermission),
        mutualExclusiveWith: []
      }
    ]
  }
];
